export enum CoreCatalogItemApiTags {
  CatalogItem = 'CatalogItem',
  CatalogItemAuthorContacts = 'CatalogItemAuthorContacts',
  ResumeFeedbacks = 'ResumeFeedbacks',
}

export const coreCatalogItemApiTagTypes = Object.values(CoreCatalogItemApiTags);
